import React from 'react'
import PropTypes from 'prop-types'

import S from '../Loading.styled'

const Button = ({ className }) => {
  return <S.Button className={className}></S.Button>
}

Button.propTypes = {
  className: PropTypes.string,
}

export default Button
